var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"active":_vm.$store.state.sidebars.showPersonalDocumentsEditForm,"icon":_vm.sidebar.icon,"title":_vm.sidebar.title}},[(_vm.$store.state.sidebars.showPersonalDocumentsEditForm)?_c('personal-documents-edit-form',{attrs:{"data":_vm.$store.state.sidebars.showPersonalDocumentsEditForm}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }